import React from 'react';
import { MapPin } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';
import SignUpLink from './SignUpLink';

export default function Support() {
  const { t } = useI18n();
  const { support } = useBookersContent();

  return (
    <section className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
      <div className="reveal rounded-[2.5rem] bg-pastel-lav border border-black/5 overflow-hidden">
        <div className="grid lg:grid-cols-2 gap-10 items-center p-8 md:p-14">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-white/70 px-3 py-1 text-xs font-semibold text-[#76B828]">
              <MapPin size={13} /> {support.eyebrow}
            </span>
            <h2 className="font-display text-4xl md:text-5xl mt-4 text-[#0b0b0f]">{support.title}</h2>
            <p className="text-[#55555f] mt-4 text-lg max-w-md">{support.text}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              {support.languages.map((l) => (
                <span key={l} className="rounded-full bg-white border border-black/5 px-4 py-1.5 text-sm font-medium text-[#0b0b0f]">{l}</span>
              ))}
            </div>
            <SignUpLink className="btn-pill btn-dark px-7 py-3.5 text-[15px] mt-8 inline-flex">
              {t('support.talkToTeam')}
            </SignUpLink>
          </div>

          <div className="grid sm:grid-cols-3 gap-4">
            {support.stats.map((s) => (
              <div key={s.note} className="rounded-2xl bg-white border border-black/5 p-6 text-center">
                <span className="mx-auto h-11 w-11 rounded-xl bg-[#EEF6DC] flex items-center justify-center">
                  <s.icon size={20} className="text-[#76B828]" />
                </span>
                <p className="font-display text-2xl mt-4 text-[#0b0b0f]">{s.value}</p>
                <p className="text-sm text-[#6b6b73] mt-1">{s.note}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
